import type { IwTileOwner } from "../infinite-war-rules";
import { TILE_LOOK } from "./layout";

export type DominionTileLook = {
  spriteId: string;
  tint: string;
  alpha: number;
};

/**
 * Sticky dominion → TILE_LOOK sprite + low-chroma tint.
 * Contested overrides owner art; empty never-claimed stays neutral.
 */
export function resolveDominionTileLook(
  owner: IwTileOwner,
  contested: boolean,
  col: number,
  row: number,
): DominionTileLook {
  const checkerMul = (col + row) % 2 === 0 ? 1 : TILE_LOOK.checkerAlphaMul;
  const alpha = TILE_LOOK.alpha * checkerMul;
  if (contested) {
    return {
      spriteId: TILE_LOOK.contestedId,
      tint: TILE_LOOK.contestedTint,
      alpha,
    };
  }
  if (owner === "south") {
    return {
      spriteId: TILE_LOOK.celestialId,
      tint: TILE_LOOK.celestialTint,
      alpha,
    };
  }
  if (owner === "north") {
    return {
      spriteId: TILE_LOOK.deathId,
      tint: TILE_LOOK.deathTint,
      alpha,
    };
  }
  return {
    spriteId: TILE_LOOK.neutralId,
    tint: TILE_LOOK.neutralTint,
    alpha,
  };
}
